import { render, staticRenderFns } from "./applyWaiting.vue?vue&type=template&id=767872dc&scoped=true"
import script from "./applyWaiting.vue?vue&type=script&lang=js"
export * from "./applyWaiting.vue?vue&type=script&lang=js"
import style0 from "./applyWaiting.vue?vue&type=style&index=0&id=767872dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767872dc",
  null
  
)

export default component.exports